<app-page-body>
  <!-- header -->
  <app-page-header
    class="d-print-none"
    [title]="pageVocabs + 'title'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <section class="invoice">
      <!-- header -->
      <div class="invoice__header seperator">
        <h1 class="tw-mr-2">{{ "common.invoice" | translate }}</h1>

        <div>
          <div class="invoice__item tw-mr-3 tw-justify-between">
            <span class="invoice__key tw-mb-1"
              >{{ "common.orderId" | translate }} :</span
            >
            <span class="invoice__value"> #548789 </span>
          </div>
          <div class="invoice__item tw-mr-3 tw-justify-between">
            <span class="invoice__key tw-mb-1">
              {{ "common.date" | translate }} :</span
            >
            <span class="invoice__value"> 1399/05/04 </span>
          </div>
          <div class="invoice__item tw-mr-3 tw-justify-between">
            <span class="invoice__key tw-mb-1">
              {{ "common.hour" | translate }} :</span
            >
            <span class="invoice__value"> 18:30 </span>
          </div>
        </div>
      </div>

      <!-- section 1-->
      <div class="row seperator">
        <!-- seller -->
        <div class="md:tw-w-1/2 invoice__item flex-column table-responsive">
          <span class="invoice__key tw-mb-3"
            >{{
              "pagesfinancial.newPayment.invoice.sellerSpecifications"
                | translate
            }}
            :</span
          >
          <table class="table table-sm">
            <tbody>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{
                    "pagesfinancial.newPayment.invoice.realLegalPersonName"
                      | translate
                  }}
                </td>
                <td class="invoice__td-value">
                  {{ "common.pishgamRayanDadehPajoohCo" | translate }}
                </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.state" | translate }}
                </td>
                <td class="invoice__td-value">
                  {{ "common.esfahan" | translate }}
                </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">{{ "common.city" | translate }}</td>
                <td class="invoice__td-value">
                  {{ "common.esfahan" | translate }}
                </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.phoneNumberFax" | translate }}
                </td>
                <td class="invoice__td-value">36633889-03136632627</td>
              </tr>

              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.address" | translate }}
                </td>

                <td class="invoice__td-value">
                  {{ "common.pishgamRayanAddress" | translate }}
                  {{ "common.pishgamRayanAddress" | translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- buyer -->
        <div class="md:tw-w-1/2 invoice__item flex-column table-responsive">
          <span class="invoice__key tw-mb-3">
            {{
              "pagesfinancial.newPayment.invoice.customerSpecifications"
                | translate
            }}
            :</span
          >
          <table class="table table-sm">
            <tbody>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{
                    "pagesfinancial.newPayment.invoice.realLegalPersonName"
                      | translate
                  }}
                </td>
                <td class="invoice__td-value">
                  {{ "common.pishgamRayanDadehPajoohCo" | translate }}
                </td>
              </tr>
              <!-- <tr class="invoice__td-item">
                <td class="invoice__td-key">شماره اقتصادی</td>
                <td class="invoice__td-value"> 411617446319 </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">شماره ثبت /شماره ملی </td>
                <td class="invoice__td-value">14007526790/61187</td>
              </tr> -->
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.state" | translate }}
                </td>
                <td class="invoice__td-value">
                  {{ "common.esfahan" | translate }}
                </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">{{ "common.city" | translate }}</td>
                <td class="invoice__td-value">
                  {{ "common.esfahan" | translate }}
                </td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.postalCode" | translate }}
                </td>
                <td class="invoice__td-value">8165755683</td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.phoneNumberFax" | translate }}
                </td>
                <td class="invoice__td-value">36633889-03136632627</td>
              </tr>

              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{ "common.address" | translate }}
                </td>

                <td class="invoice__td-value">
                  {{ "common.pishgamRayanAddress" | translate }}
                  {{ "common.pishgamRayanAddress" | translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- section 2-->
      <div class="row seperator tw-flex">
        <!-- alerts -->
        <div class="md:tw-w-1/2 invoice__alerts">
          <p class="tw-mb-2">
            *
            {{
              "pagesfinancial.newPayment.invoice.invoiceIssuance" | translate
            }}
          </p>
          <p>
            *
            {{ "pagesfinancial.newPayment.invoice.noLegalValue" | translate }}
          </p>
        </div>

        <!-- final table -->
        <div
          class="md:tw-w-1/2 invoice__item tw-flex flex-column table-responsive"
        >
          <table class="table table-sm">
            <tbody>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{
                    "pagesfinancial.newPayment.invoice.valueAddedTaxRial"
                      | translate
                  }}
                </td>
                <td class="invoice__td-value">500,000</td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key">
                  {{
                    "pagesfinancial.newPayment.invoice.parliamentTax"
                      | translate
                  }}
                </td>
                <td class="invoice__td-value">500,000</td>
              </tr>
              <tr class="invoice__td-item">
                <td class="invoice__td-key tw-font-semibold td-bg-success">
                  {{
                    "pagesfinancial.newPayment.invoice.totalAmountRial"
                      | translate
                  }}
                </td>
                <td
                  class="invoice__td-value tw-font-semibold tw-text-lg td-text-success"
                >
                  10000,000
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- form btns-->
      <div class="tw-flex-center d-print-none tw-mt-5">
        <button matRipple class="btn tw-ml-2" [themeColor]="'btn'">
          {{ "pagesfinancial.newPayment.invoice.finalPayment" | translate }}
        </button>

        <button matRipple class="btn btn-secondary" (click)="onPrint()">
          {{ "common.print" | translate }}
          <span> <i class="mdi mdi-printer tw-text-xl"></i> </span>
        </button>
      </div>
    </section>
  </div>
</app-page-body>
